import { render, staticRenderFns } from "./MyJobTrayAssigned.vue?vue&type=template&id=36d3ff67&scoped=true"
import script from "./MyJobTrayAssigned.vue?vue&type=script&lang=js"
export * from "./MyJobTrayAssigned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d3ff67",
  null
  
)

export default component.exports